import React from 'react'
import {useStyles} from "./ScoredSceneCardDetailed.css";
import TagContainer from "../../../../../commons/utils/disciplines/TagContainer";
import ScoredSceneSummarySlider from "../../utils/sliders/ScoredSceneSummarySlider";
import {VideoCutSlider} from "../../overview/ScoredScenesSection.css";
import DifficultyIndication from "../../../../../commons/utils/difficulty/DifficultyIndication";
import ScoredSceneCardBasic from "../scoredSceneCardBasic/ScoredSceneCardBasic";

const ScoredSceneCardDetailed = ({scoredScene}) => {
    const classes = useStyles()

    return <div className={classes.root}>
        <ScoredSceneCardBasic scoredScene={scoredScene}

                              enrichedComponentTop={
                                  <div className={classes.horizontalSpacedContainer}>
                                      <VideoCutSlider
                                          value={[scoredScene.basics.sceneStart, scoredScene.basics.sceneEnd]}
                                          valueLabelDisplay="off"
                                          min={0}
                                          max={scoredScene.video.vimeo.duration}
                                      />
                                  </div>}

                              enrichedComponentBottom={
                                  <div className={classes.spacedContainer}>
                                      <ScoredSceneSummarySlider scoredScene={scoredScene} timeFormat="ss"/>
                                  </div>}

                              enrichedComponentHeader={
                                  <div className={classes.horizontalSpacedContainer}>
                                      <DifficultyIndication difficulty={scoredScene.basics.difficulty}/>
                                  </div>}

                              enrichedComponentBody={
                                  <div className={classes.horizontalSpacedContainer}>
                                      <TagContainer tags={scoredScene.basics.mainFocus}/>
                                  </div>}
        />
    </div>
}
export default ScoredSceneCardDetailed